import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgComplexJourneyIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25.098 2.666a3.905 3.905 0 0 0-3.902 3.902c0 1.875 1.481 5.32 3.902 5.32 2.42 0 3.902-3.445 3.902-5.32a3.905 3.905 0 0 0-3.902-3.902m0 7.094c-.697 0-1.773-1.94-1.773-3.192 0-.978.795-1.774 1.773-1.774s1.774.796 1.774 1.774c0 1.253-1.077 3.192-1.774 3.192M5.235 22.53a3.905 3.905 0 0 0-3.902 3.901 3.905 3.905 0 0 0 3.902 3.902 3.905 3.905 0 0 0 3.901-3.902 3.905 3.905 0 0 0-3.901-3.902Zm0 5.674a1.776 1.776 0 0 1-1.774-1.773c0-.978.796-1.774 1.774-1.774.977 0 1.773.796 1.773 1.774 0 .977-.796 1.773-1.773 1.773m18.09-6.03a5.327 5.327 0 0 1-5.321 5.321h-5.675a1.064 1.064 0 0 1 0-2.128h5.675a3.196 3.196 0 0 0 3.192-3.192 3.196 3.196 0 0 0-3.192-3.193H10.2a4.616 4.616 0 0 1-4.61-4.61A4.616 4.616 0 0 1 10.2 9.76h9.223a1.065 1.065 0 0 1 0 2.128H10.2a2.486 2.486 0 0 0-2.483 2.483 2.486 2.486 0 0 0 2.482 2.483h7.804a5.327 5.327 0 0 1 5.32 5.32Z" />
  </svg>
);
export default SvgComplexJourneyIcon;
